import { SelectMenuItem } from "evergreen-ui";
import { CostPayoutModifier, ProductListingToPayoutRule } from "../../../../../../common/models";
import { ColumnConfig } from "../../../../common/tables/config/ColumnConfig";
import { EnumResolver } from "../../../../common/tables/etc/EnumResolver";
import { SupportedColor } from "../../../../common/tables/etc/StyledSelectMenuItem";
import { TableCellFactory } from "../../../../common/tables/factory";
import { PLPRTableRow } from "../../../../../../common/tables/product-listing/payout-rule-mapping/PLPRTableRow";
import { PLPREnumMapper } from "../etc/PLPREnumMapper";

export class PLPRTableCellFactory extends TableCellFactory<PLPRTableRow, ProductListingToPayoutRule> {
    readonly enumResolver: EnumResolver<PLPRTableRow> = new PLPREnumMapper();
    private _costPayoutModifiers: CostPayoutModifier[] = [];

    setCostPayoutModifiers(modifiers: CostPayoutModifier[]): void {
        this._costPayoutModifiers = modifiers;
    }

    public resolveFilterOptions(column: ColumnConfig<PLPRTableRow>): SelectMenuItem[] {
        if ((column.columnName as string) === "costPayoutModifierId") {
            return [
                { label: "None", value: "" },
                ...this._costPayoutModifiers.map(m => ({ label: m.name, value: m.id })),
            ];
        }
        return super.resolveFilterOptions(column);
    }

    protected resolveCellBadgeColor(
        _columnConfig: ColumnConfig<PLPRTableRow>,
        _rowData: ProductListingToPayoutRule,
    ): SupportedColor {
        return undefined;
    }

    protected resolveCellData(
        columnConfig: ColumnConfig<PLPRTableRow>,
        rowData: ProductListingToPayoutRule,
    ): string {
        const colName = columnConfig.columnName as string;

        if (colName === "payoutRuleName") {
            return rowData.payoutRule?.name ?? "";
        }

        if (colName === "payoutRuleType") {
            return rowData.payoutRule?.type ?? "";
        }

        if (colName === "costPayoutModifierName") {
            return rowData.costPayoutModifier?.name ?? "Default";
        }

        if (colName === "costPayoutModifierId") {
            return rowData.costPayoutModifier?.name ?? rowData.costPayoutModifierId ?? "";
        }

        // Flatten nested payoutRule percent fields
        const payoutRuleFields: Record<string, keyof typeof rowData.payoutRule> = {
            vendorProfitSplitPercent: "vendorProfitSplitPercent",
            retailPricePercentApplicable: "retailPricePercentApplicable",
            unitCostPercentApplicable: "unitCostPercentApplicable",
            juniperServiceFeePercentApplicable: "juniperServiceFeePercentApplicable",
            fulfillmentFeePercentApplicable: "fulfillmentFeePercentApplicable",
            processingFeePercentApplicable: "processingFeePercentApplicable",
            shippingSubsidyPercentApplicable: "shippingSubsidyPercentApplicable",
        };
        if (colName in payoutRuleFields) {
            const val = rowData.payoutRule?.[payoutRuleFields[colName] as keyof typeof rowData.payoutRule];
            return val !== undefined && val !== null ? String(val) : "";
        }

        return super.resolveCellData(columnConfig, rowData);
    }
}
